// Open print-ready HTML in a new window via a Blob URL (avoids document.write / XSS sinks).
// Modern Chrome blocks window.print() outside a user gesture, so the opened
// document also gets a fixed 印刷 button — the auto attempt below is best-effort.
const PRINT_BUTTON_HTML = `
<style>
  .__pw-print-btn{position:fixed;top:12px;right:12px;z-index:99999;padding:10px 20px;
    background:#0F766E;color:#fff;border:none;border-radius:8px;font-size:14px;
    font-weight:bold;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25);font-family:sans-serif}
  .__pw-print-btn:hover{background:#115E59}
  .__pw-copies-note{position:fixed;top:12px;left:12px;z-index:99999;max-width:360px;
    padding:8px 12px;background:#fef3c7;border:1px solid #fbbf24;border-radius:8px;
    color:#78350f;font-size:12px;line-height:1.5;font-family:sans-serif;
    box-shadow:0 2px 10px rgba(0,0,0,.10)}
  .__pw-copies-note b{font-weight:700}
  @media print{.__pw-print-btn,.__pw-copies-note{display:none!important}}
</style>
<div class="__pw-copies-note" data-testid="print-copies-reminder">
  印刷前に <b>部数（Copies）</b> が <b>1</b> になっていることをご確認ください。
</div>
<button type="button" class="__pw-print-btn" onclick="window.print()">印刷 / PDF保存</button>
`;

export function openPrintWindow(html, { delay = 400, features } = {}) {
  const withButton = html.includes('</body>')
    ? html.replace('</body>', `${PRINT_BUTTON_HTML}</body>`)
    : html + PRINT_BUTTON_HTML;
  const blob = new Blob([withButton], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const w = features ? window.open(url, '_blank', features) : window.open(url, '_blank');
  if (!w) { URL.revokeObjectURL(url); return null; }
  setTimeout(() => {
    try { w.focus(); w.print(); } catch (_e) { /* user prints via the button */ }
    URL.revokeObjectURL(url);
  }, delay);
  return w;
}
